import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from 'element-ui';
import "@/assets/style/index.less"
import 'element-ui/lib/theme-chalk/index.css';
import "./permission"
import "@/assets/font_4030178_8cv98zds4lv/iconfont.css"
import $ from 'jquery'
import _ from 'lodash'
import moment from "moment"
// 
import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;
Vue.prototype.$moment = moment;
Vue.prototype.window = window;
Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.prototype.$ = $;
Vue.prototype.$tableHeight = window.innerHeight - 270
//_.debounce(fun,1000) 防抖   _.throttle(fun,1000)节流
Vue.prototype._ = _;

window.Vue = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

